"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var React = require("react");
var Pages_1 = require("@/rendering/common/Pages");
var MegaMenuAction_1 = require("@/pages/common/actions/MegaMenuAction");
var classNames = require("classnames");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var MegaMenuSearchPopup_1 = require("@/pages/common/components/MegaMenuSearchPopup");
var LanguageSwitcher_1 = require("@/components/LanguageSwitcher");
var mapStateToProps = function (state, ownProps) {
    var _a;
    return (__assign(__assign({}, state.layout), { userName: state.user.firstname ? state.user.firstname : state.user.email, userId: state.user.id || "", userFrom: state.user.from || "", userEmail: state.user.email || "", isNotConfirmed: !state.user.isConfirmed, hideAlert: state.page === Pages_1.Pages.CONFIRM_EMAIL_REGISTER ? true : false, showFav: state.page === Pages_1.Pages.SEARCH, page: state.page, lang: state.layout.language.languages
            .filter(function (it) { return it.id === state.layout.language.current; })[0]
            .code1.toLowerCase(), langShort: state.layout.language.languages
            .filter(function (it) { return it.id !== state.layout.language.current; })[0]
            .shortName.toUpperCase(), currencyShort: state.layout.currencies.options.filter(function (it) { return it.key === state.layout.currencies.currentCurrencyId; })[0].symbol, t: state.translate, hideSettings: ownProps ? ownProps.hideSettings : false, tel: state.layout.offices[0].telephone, nobottom: ownProps && ownProps.nobottom ? ownProps.nobottom : false, nosearch: ownProps && ownProps.nosearch ? ownProps.nosearch : false, isMobile: state.mobile || false, linkCareers: state.layout.careerUrl, pendingDocumentCount: state.user.id && state.side
            ? (_a = state.side.items
                .find(function (it) {
                return it.children &&
                    it.children.find(function (it2) { return it2.page === Pages_1.Pages.PENDING_DOCUMENT; });
            })) === null || _a === void 0 ? void 0 : _a.children.find(function (it) { return it.page === Pages_1.Pages.PENDING_DOCUMENT; }).count : 0 }));
};
var mapDispatchToProps = function (dispatch) { return ({
    onMegaMenuLeave: function () { return dispatch(MegaMenuAction_1.default.setAllPopupsActive(false)); },
    onBuySelected: function () { return dispatch(MegaMenuAction_1.default.setBuyPopupActive(true)); },
    onBuyHover: function () { return dispatch(MegaMenuAction_1.default.onBuyHover()); },
    onBuyToggle: function () { return dispatch(MegaMenuAction_1.default.onBuyToggle()); },
    onRentSelected: function () { return dispatch(MegaMenuAction_1.default.setRentPopupActive(true)); },
    onRentHover: function () { return dispatch(MegaMenuAction_1.default.onRentHover()); },
    onRentToggle: function () { return dispatch(MegaMenuAction_1.default.onRentToggle()); },
    onAgentSelected: function () { return dispatch(MegaMenuAction_1.default.setAgentPopupActive(true)); },
    onAgentHover: function () { return dispatch(MegaMenuAction_1.default.onAgentHover()); },
    onAgentToggle: function () { return dispatch(MegaMenuAction_1.default.onAgentToggle()); },
    onResourcesSelected: function () {
        return dispatch(MegaMenuAction_1.default.setResourcesPopupActive(true));
    },
    onResourcesHover: function () { return dispatch(MegaMenuAction_1.default.onResourcesHover()); },
    onResourcesToggle: function () { return dispatch(MegaMenuAction_1.default.onResourcesToggle()); },
    onAboutUsSelected: function () { return dispatch(MegaMenuAction_1.default.setAboutUsPopupActive(true)); },
    onAboutUsHover: function () { return dispatch(MegaMenuAction_1.default.onAboutUsHover()); },
    onAboutUsToggle: function () { return dispatch(MegaMenuAction_1.default.onAboutUsToggle()); },
    onLanguageEnter: function () { return dispatch(MegaMenuAction_1.default.onLanguageEnter()); },
    onLanguageToggle: function () { return dispatch(MegaMenuAction_1.default.onLanguageToggle()); },
    onMobileTopMenuClick: function () { return dispatch(MegaMenuAction_1.default.onMobileTopMenuClick()); },
    onMobileBack: function () { return dispatch(MegaMenuAction_1.default.onMobileBack()); },
    onMobileResourceBack: function () { return dispatch(MegaMenuAction_1.default.onMobileResourceBack()); },
    onAccountMenuToggle: function () { return dispatch(MegaMenuAction_1.default.onAccountMenuToggle()); },
    onFavoriteMenuToggle: function () { return dispatch(MegaMenuAction_1.default.onFavoriteMenuToggle()); },
    onMobileLangToggle: function () { return dispatch(MegaMenuAction_1.default.onMobileLangToggle()); },
    onBuyPopularDistrictToggle: function () {
        return dispatch(MegaMenuAction_1.default.onBuyPopularDistrictToggle());
    },
    onBuyPopularBuildingToggle: function () {
        return dispatch(MegaMenuAction_1.default.onBuyPopularBuildingToggle());
    },
    onRentPopularDistrictToggle: function () {
        return dispatch(MegaMenuAction_1.default.onRentPopularDistrictToggle());
    },
    onRentPopularBuildingToggle: function () {
        return dispatch(MegaMenuAction_1.default.onRentPopularBuildingToggle());
    },
    onLoginClicked: function () { return dispatch(MegaMenuAction_1.default.onLoginClicked()); },
    onLogoutClicked: function () { return dispatch(MegaMenuAction_1.default.onLogoutClicked()); },
    onMyAccountClick: function () { return dispatch(MegaMenuAction_1.default.onMyAccountClick()); },
    onFavoriteClick: function () { return dispatch(MegaMenuAction_1.default.onFavoriteClick()); },
    onSetLanguage: function (language) {
        return dispatch(LayoutAction_1.default.onSetLanguage(language));
    },
    onSearchIconClick: function () { return dispatch(MegaMenuAction_1.default.onSearchIconClick()); },
    onCallClick: function () { return dispatch(MegaMenuAction_1.default.onCallClick()); },
    onEmailClick: function () { return dispatch(MegaMenuAction_1.default.onEmailClick()); },
    onResourceForSaleClicked: function () {
        return dispatch(MegaMenuAction_1.default.onResourceForSaleClicked());
    },
    onResourceForRentClicked: function () {
        return dispatch(MegaMenuAction_1.default.onResourceForRentClicked());
    },
    onMobileResourcePopularDistrictsClicked: function () {
        return dispatch(MegaMenuAction_1.default.onMobileResourcePopularDistrictsClicked());
    },
    onMobileResourcePopularBuildingsClicked: function () {
        return dispatch(MegaMenuAction_1.default.onMobileResourcePopularBuildingsClicked());
    },
    onMobileResourceForSaleClick: function () {
        return dispatch(MegaMenuAction_1.default.onMobileResourceForSaleClick());
    },
    onMobileResourceForRentClick: function () {
        return dispatch(MegaMenuAction_1.default.onMobileResourceForRentClick());
    },
}); };
var megaMenuComponent = function (props) {
    var t = props.tMegamenu;
    var megamenu = props.megamenu;
    var currentLang = props.lang;
    var displayName = props.userName || props.userEmail;
    var isUnverified = props.isNotConfirmed;
    var buyMenuButtonAttr = props.isMobile
        ? {}
        : { href: "/" + currentLang + "/property-search/buy" };
    var rentMenuButtonAttr = props.isMobile
        ? {}
        : { href: "/" + currentLang + "/property-search/rent" };
    var buyPopupClasses = classNames([
        "c-mega__main-nav-pop",
        { "c-mega__main-nav-pop--active": megamenu.buyPopupActive },
    ]);
    var rentPopupClasses = classNames([
        "c-mega__main-nav-pop",
        { "c-mega__main-nav-pop--active": megamenu.rentPopupActive },
    ]);
    var agentPopupClasses = classNames([
        "c-mega__agent",
        { "c-mega__agent--active": megamenu.agentPopupActive },
    ]);
    var aboutUsPopupClasses = classNames([
        "c-mega__about",
        { "c-mega__about--active": megamenu.aboutUsPopupActive },
    ]);
    var resourcesPopupClasses = classNames([
        "c-mega__resource",
        { "c-mega__resource--active": megamenu.resourcesPopupActive },
    ]);
    var langPopupClass = classNames([
        "l-mega__langs",
        "c-mega__langs",
        { "c-mega__langs--active": megamenu.languagesPopupActive },
    ]);
    var megaBodyClass = classNames([
        "l-mega__body",
        {
            "l-mega__body--active": megamenu.mobileMenuActive,
            "l-mega__body--sub-active": megamenu.buyPopupActive ||
                megamenu.rentPopupActive ||
                megamenu.agentPopupActive ||
                megamenu.resourcesPopupActive ||
                megamenu.aboutUsPopupActive,
        },
    ]);
    var accountClass = classNames([
        "c-mega__account",
        "c-mega__li",
        { "c-mega__account--active": megamenu.accountActive },
    ]);
    var favoriteClass = classNames([
        "c-mega__favorite",
        "c-mega__li",
        { "c-mega__favorite--active": megamenu.favoriteActive },
    ]);
    var langClass = classNames([
        "c-mega__langs-drop",
        { "c-mega__langs-drop--active": megamenu.mobileLangActive },
    ]);
    var buyPopularDistrictClass = classNames([
        "c-mega__main-nav-pop-li",
        "c-mega__li",
        { "c-mega__main-nav-pop-li--active": megamenu.popularDistrictBuyActive },
    ]);
    var rentPopularDistrictClass = classNames([
        "c-mega__main-nav-pop-li",
        "c-mega__li",
        { "c-mega__main-nav-pop-li--active": megamenu.popularDistrictRentActive },
    ]);
    var buyPopularBuildingClass = classNames([
        "c-mega__main-nav-pop-li",
        "c-mega__li",
        { "c-mega__main-nav-pop-li--active": megamenu.popularBuildingBuyActive },
    ]);
    var rentPopularBuildingClass = classNames([
        "c-mega__main-nav-pop-li",
        "c-mega__li",
        { "c-mega__main-nav-pop-li--active": megamenu.popularBuildingRentActive },
    ]);
    var megaClass = classNames([
        "l-mega",
        {
            "l-mega--with-bottom": !props.nobottom,
            "l-mega--nosearch": props.nosearch,
        },
    ]);
    var resourceForSaleBtnClass = classNames([
        "c-mega__resource-toggle-btn",
        { "c-mega__resource-toggle-btn--active": megamenu.isResourceSaleActive },
    ]);
    var resourceForRentBtnClass = classNames([
        "c-mega__resource-toggle-btn",
        { "c-mega__resource-toggle-btn--active": megamenu.isResourceRentActive },
    ]);
    var resourceForSaleTarget = classNames([
        "c-mega__resource-pop-toggle-target",
        {
            "c-mega__resource-pop-toggle-target--active": megamenu.isResourceSaleActive,
        },
    ]);
    var resourceForRentTarget = classNames([
        "c-mega__resource-pop-toggle-target",
        {
            "c-mega__resource-pop-toggle-target--active": megamenu.isResourceRentActive,
        },
    ]);
    var mobileResourcePopularDistrictsTargets = classNames([
        "c-mega__resource-pop-toggle-targets",
        {
            "c-mega__resource-pop-toggle-targets--active": megamenu.isMobileResourcePopularDistrictsActive,
        },
    ]);
    var mobileResourcePopularBuildingsTargets = classNames([
        "c-mega__resource-pop-toggle-targets",
        {
            "c-mega__resource-pop-toggle-targets--active": megamenu.isMobileResourcePopularBuildingsActive,
        },
    ]);
    var userAlertClass = megamenu.isUserAlert ? "c-mega__account--alert" : "";
    var setLanguage = function (language) {
        var selectedLanguage = props.language.languages.find(function (it) { return it.id === language; });
        if (selectedLanguage)
            return function () { return props.onSetLanguage(selectedLanguage); };
        return function () { };
    };
    var renderLocationItem = function (item, i) {
        return (React.createElement("li", { key: i },
            React.createElement("a", { href: item.url },
                React.createElement("span", null, item.name),
                item.image ? (React.createElement("div", null,
                    React.createElement("img", { "data-lazy": "manual", "data-src": item.image, alt: item.name }))) : null)));
    };
    var renderLocationItemNoImage = function (item, i) {
        return (React.createElement("li", { key: i },
            React.createElement("a", { href: item.url }, item.name)));
    };
    var renderRentPopularBuilding = function (props) {
        var items = props.megamenu.rentPopularBuildings;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItem) : null));
    };
    var renderRentBuilding = function (props) {
        var items = props.megamenu.rentBuildings;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItemNoImage) : null));
    };
    var renderBuyPopularBuilding = function (props) {
        var items = props.megamenu.buyPopularBuildings;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItem) : null));
    };
    var renderBuyBuilding = function (props) {
        var items = props.megamenu.buyBuildings;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItemNoImage) : null));
    };
    var renderBuyPopularDistrict = function (props) {
        var items = props.megamenu.buyPopularDistricts;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItem) : null));
    };
    var renderBuyDistrict = function (props) {
        var items = props.megamenu.buyDistricts;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItemNoImage) : null));
    };
    var renderRentPopularDistrict = function (props) {
        var items = props.megamenu.rentPopularDistricts;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItem) : null));
    };
    var renderRentDistrict = function (props) {
        var items = props.megamenu.rentDistricts;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItemNoImage) : null));
    };
    var renderRentPopularBuildingResources = function (props) {
        var items = props.megamenu.rentPopularBuildingsResources;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItem) : null));
    };
    var renderRentBuildingResources = function (props) {
        var items = props.megamenu.rentBuildingsResources;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItemNoImage) : null));
    };
    var renderBuyPopularBuildingResources = function (props) {
        var items = props.megamenu.buyPopularBuildingsResources;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItem) : null));
    };
    var renderBuyBuildingResources = function (props) {
        var items = props.megamenu.buyBuildingsResources;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItemNoImage) : null));
    };
    var renderBuyPopularDistrictResources = function (props) {
        var items = props.megamenu.buyPopularDistrictsResources;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItem) : null));
    };
    var renderBuyDistrictResources = function (props) {
        var items = props.megamenu.buyDistrictsResources;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItemNoImage) : null));
    };
    var renderRentPopularDistrictResources = function (props) {
        var items = props.megamenu.rentPopularDistrictsResources;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItem) : null));
    };
    var renderRentDistrictResources = function (props) {
        var items = props.megamenu.rentDistrictsResources;
        return (React.createElement("ul", null, items && items.length ? items.map(renderLocationItemNoImage) : null));
    };
    var onBuyClicked = function (e) {
        if (props.isMobile) {
            e.preventDefault();
            props.onBuyToggle();
        }
    };
    var onRentClicked = function (e) {
        if (props.isMobile) {
            e.preventDefault();
            props.onRentToggle();
        }
    };
    var onResourceForSaleClicked = function (e) {
        e.preventDefault();
        props.onResourceForSaleClicked();
    };
    var onResourceForRentClicked = function (e) {
        e.preventDefault();
        props.onResourceForRentClicked();
    };
    var onMobileResourcePopularDistrictsClicked = function (e) {
        e.preventDefault();
        props.onMobileResourcePopularDistrictsClicked();
    };
    var onMobileResourcePopularBuildingsClicked = function (e) {
        e.preventDefault();
        props.onMobileResourcePopularBuildingsClicked();
    };
    var mobileResourceForSaleClick = function (e) {
        e.preventDefault();
        props.onMobileResourceForSaleClick();
    };
    var mobileResourceForRentClick = function (e) {
        e.preventDefault();
        props.onMobileResourceForRentClick();
    };
    return (React.createElement("div", { className: megaClass },
        React.createElement("div", { className: "l-mega__top c-mega__top " + (megamenu.mobileMenuActive ? "l-mega__top--active" : "") },
            React.createElement("div", { className: "c-mega__top-menu" },
                React.createElement("a", { onClick: props.onMobileTopMenuClick },
                    React.createElement("span", { className: "fal fa-bars " + (props.pendingDocumentCount ? "c-mega__account--alert" : "") }),
                    React.createElement("span", { className: "fal fa-times" }))),
            React.createElement("div", { className: "c-mega__top-logo" },
                React.createElement("a", { href: "/" + currentLang },
                    React.createElement("img", { id: "okay-forbes-logo-550", alt: "OKAY.COM | Founding member of Forbes Global Properties", src: "/res/img/okay-logo-sm2.png" }))),
            React.createElement("div", { className: "c-mega__top-search" },
                React.createElement("a", { onClick: props.onSearchIconClick },
                    React.createElement("span", { className: "fal fa-search" })))),
        React.createElement("div", { className: megaBodyClass },
            React.createElement("div", { className: "l-mega__container" },
                React.createElement("div", { className: "l-mega__nav" },
                    React.createElement("nav", { id: "nav", className: "c-mega", itemScope: true, itemType: "http://www.schema.org/SiteNavigationElement" },
                        React.createElement("ul", { onMouseLeave: props.onMegaMenuLeave, className: "c-mega__main-nav" },
                            React.createElement("li", { className: "c-mega__li" },
                                React.createElement("a", __assign({}, buyMenuButtonAttr, { onClick: onBuyClicked, onMouseOver: props.onBuyHover }), t.buy),
                                React.createElement("ul", { className: buyPopupClasses },
                                    React.createElement("li", { className: buyPopularDistrictClass },
                                        React.createElement("a", { onClick: props.onBuyPopularDistrictToggle }, t.popularDistrict),
                                        renderBuyPopularDistrict(props),
                                        renderBuyDistrict(props)),
                                    React.createElement("li", { className: buyPopularBuildingClass },
                                        React.createElement("a", { onClick: props.onBuyPopularBuildingToggle }, t.popularBuilding),
                                        renderBuyPopularBuilding(props),
                                        renderBuyBuilding(props)),
                                    React.createElement("li", { className: "c-mega__viewmore" },
                                        React.createElement("a", { href: "/" + currentLang + "/property-search/buy" }, t.viewAllForSale)),
                                    React.createElement("li", { className: "c-mega__back" },
                                        React.createElement("a", { onClick: props.onMobileBack },
                                            React.createElement("span", { className: "fal fa-long-arrow-left" }),
                                            React.createElement("span", null, t.buy))))),
                            React.createElement("li", { className: "c-mega__li" },
                                React.createElement("a", __assign({}, rentMenuButtonAttr, { onClick: onRentClicked, onMouseOver: props.onRentHover }), t.rent),
                                React.createElement("ul", { className: rentPopupClasses },
                                    React.createElement("li", { className: rentPopularDistrictClass },
                                        React.createElement("a", { onClick: props.onRentPopularDistrictToggle }, t.popularDistrict),
                                        renderRentPopularDistrict(props),
                                        renderRentDistrict(props)),
                                    React.createElement("li", { className: rentPopularBuildingClass },
                                        React.createElement("a", { onClick: props.onRentPopularBuildingToggle }, t.popularBuilding),
                                        renderRentPopularBuilding(props),
                                        renderRentBuilding(props)),
                                    React.createElement("li", { className: "c-mega__viewmore" },
                                        React.createElement("a", { href: "/" + currentLang + "/property-search/rent" }, t.viewAllForRent)),
                                    React.createElement("li", { className: "c-mega__back" },
                                        React.createElement("a", { onClick: props.onMobileBack },
                                            React.createElement("span", { className: "fal fa-long-arrow-left" }),
                                            React.createElement("span", null, t.rent))))),
                            React.createElement("li", { className: "c-mega__li c-mega__li--leaf" },
                                React.createElement("a", { href: "/" + currentLang + "/exclusives", onMouseOver: props.onMegaMenuLeave }, t.ourExclusive)),
                            React.createElement("li", { className: "c-mega__li" },
                                React.createElement("a", { href: "/" + currentLang + "/firsthand-developments", onMouseOver: props.onMegaMenuLeave }, t.newDevelopments)),
                            React.createElement("li", { className: "c-mega__li c-mega__li--leaf" },
                                React.createElement("a", { href: "/" + currentLang + "/list-property", onMouseOver: props.onMegaMenuLeave }, t.list)),
                            React.createElement("li", { className: "c-mega__li" },
                                React.createElement("a", { onClick: props.onAgentToggle, onMouseOver: props.onAgentHover }, t.agents),
                                React.createElement("ul", { className: agentPopupClasses },
                                    React.createElement("li", null,
                                        React.createElement("a", { target: "_blank", href: props.careerUrl }, t.joinAsAnAgent),
                                        React.createElement("ul", null,
                                            React.createElement("li", null,
                                                React.createElement("a", { target: "_blank", href: props.careerUrl },
                                                    React.createElement("div", null,
                                                        React.createElement("img", { "data-src": "https://images.okay.com/website/common/images/join-okay.webp", alt: t.joinAsAnAgent })),
                                                    React.createElement("span", null, t.joinNow))))),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/property-agent-team" }, t.findAnAgent),
                                        React.createElement("ul", null,
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/property-agent-team" },
                                                    React.createElement("div", null,
                                                        React.createElement("img", { "data-src": "https://images.okay.com/website/common/images/find-an-agent2.webp", alt: t.findAnAgent })),
                                                    React.createElement("span", null, t.contactUs))))),
                                    React.createElement("li", { className: "c-mega__back" },
                                        React.createElement("a", { onClick: props.onMobileBack },
                                            React.createElement("span", { className: "fal fa-long-arrow-left" }),
                                            React.createElement("span", null, t.agents))))),
                            React.createElement("li", { className: "c-mega__li" },
                                React.createElement("a", { onClick: props.onAboutUsToggle, onMouseOver: props.onAboutUsHover }, t.aboutUs),
                                React.createElement("ul", { className: aboutUsPopupClasses },
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/about-us" }, t.aboutUs),
                                        React.createElement("ul", null,
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/about-us" }, t.ourStory)),
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/property-experts" }, t.executiveTeam)),
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/property-agent-team" }, t.ourTeam)),
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/about-us/testimonials" }, t.testimonials)),
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/about-us/in-the-press" }, t.inThePress)),
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/communication/enquiry" }, t.contactUs)))),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/about-us" }, t.ourStory),
                                        React.createElement("ul", null,
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/about-us" },
                                                    React.createElement("div", { className: "c-mega__ourstory" },
                                                        React.createElement("img", { "data-src": "https://images.okay.com/website/common/images/aboutbg2.webp", alt: t.ourStory })))))),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/about-us/testimonials" }, t.testimonials),
                                        React.createElement("ul", null,
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/about-us/testimonials" },
                                                    React.createElement("div", { className: "c-mega__testimonial" },
                                                        React.createElement("img", { "data-src": "https://images.okay.com/website/common/images/testimonials.webp", alt: t.testimonials })))))),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/communication/enquiry" }, t.contactUs),
                                        React.createElement("ul", null,
                                            React.createElement("li", null,
                                                React.createElement("a", { onClick: props.onCallClick },
                                                    React.createElement("div", null,
                                                        React.createElement("div", null,
                                                            React.createElement("span", { className: "fal fa-phone-alt" })),
                                                        React.createElement("div", null,
                                                            React.createElement("div", null,
                                                                t.callUsAt,
                                                                ":"),
                                                            React.createElement("div", null, t.callNumber))))),
                                            React.createElement("li", null,
                                                React.createElement("a", { onClick: props.onEmailClick },
                                                    React.createElement("div", null,
                                                        React.createElement("div", null,
                                                            React.createElement("span", { className: "fal fa-envelope" })),
                                                        React.createElement("div", null,
                                                            React.createElement("div", null,
                                                                t.emailUsAt,
                                                                ":"),
                                                            React.createElement("div", null, t.emailAddress))))))),
                                    React.createElement("li", { className: "c-mega__back" },
                                        React.createElement("a", { onClick: props.onMobileBack },
                                            React.createElement("span", { className: "fal fa-long-arrow-left" }),
                                            React.createElement("span", null, t.aboutUs))))),
                            React.createElement("li", { className: "c-mega__li" },
                                React.createElement("a", { onClick: props.onResourcesToggle, onMouseOver: props.onResourcesHover }, t.resources),
                                React.createElement("ul", { className: resourcesPopupClasses },
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/property-news" }, t.resources),
                                        React.createElement("ul", null,
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/property-news" }, t.newsAndInsights)),
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/property-questions" }, t.askAnAgent)),
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/property-guides" }, t.guides)),
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/mortgagecalculator/monthlyrepayment" }, t.mortgage)))),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/property-guides" }, t.guides),
                                        React.createElement("ul", null,
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/guides/buying" }, t.propertyGuides)),
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/guides/hong-kong-island" }, t.hkDistrictGuides)),
                                            React.createElement("li", null,
                                                React.createElement("a", { href: "/" + currentLang + "/guides/living-in-hong-kong" }, t.usefulInfo)))),
                                    React.createElement("li", { className: "c-mega__resource-popular" },
                                        React.createElement("div", { className: "c-mega__resource-toggle" },
                                            React.createElement("a", { onClick: onResourceForSaleClicked, id: "resource-for-sale", className: resourceForSaleBtnClass }, t.forSale),
                                            React.createElement("a", { onClick: onResourceForRentClicked, id: "resource-for-rent", className: resourceForRentBtnClass }, t.forRent)),
                                        React.createElement("ul", { className: "c-mega__resource-pop" },
                                            React.createElement("li", { className: "c-mega__resource-pop-li c-mega__li" },
                                                React.createElement("a", { onClick: onMobileResourcePopularDistrictsClicked, className: "c-mega__resource-pop-li-btn c-mega__resource-pop-li-btn--district" }, t.popularDistrict),
                                                React.createElement("ul", { className: mobileResourcePopularDistrictsTargets },
                                                    React.createElement("li", { className: "c-mega__back" },
                                                        React.createElement("a", { onClick: props.onMobileResourceBack },
                                                            React.createElement("span", { className: "fal fa-long-arrow-left" }),
                                                            React.createElement("span", null, t.popularDistrict))),
                                                    React.createElement("li", { className: resourceForSaleTarget },
                                                        React.createElement("a", { href: "#", className: "c-mega__resource-pop-toggle-target-toggle", onClick: mobileResourceForSaleClick }, t.forSale),
                                                        renderBuyPopularDistrictResources(props),
                                                        renderBuyDistrictResources(props)),
                                                    React.createElement("li", { className: resourceForRentTarget },
                                                        React.createElement("a", { href: "#", className: "c-mega__resource-pop-toggle-target-toggle", onClick: mobileResourceForRentClick }, t.forRent),
                                                        renderRentPopularDistrictResources(props),
                                                        renderRentDistrictResources(props)))),
                                            React.createElement("li", { className: "c-mega__resource-pop-li c-mega__li" },
                                                React.createElement("a", { onClick: onMobileResourcePopularBuildingsClicked, className: "c-mega__resource-pop-li-btn c-mega__resource-pop-li-btn--building" }, t.popularBuilding),
                                                React.createElement("ul", { className: mobileResourcePopularBuildingsTargets },
                                                    React.createElement("li", { className: "c-mega__back" },
                                                        React.createElement("a", { onClick: props.onMobileResourceBack },
                                                            React.createElement("span", { className: "fal fa-long-arrow-left" }),
                                                            React.createElement("span", null, t.popularBuilding))),
                                                    React.createElement("li", { className: resourceForSaleTarget },
                                                        React.createElement("a", { href: "#", className: "c-mega__resource-pop-toggle-target-toggle", onClick: mobileResourceForSaleClick }, t.forSale),
                                                        renderBuyPopularBuildingResources(props),
                                                        renderBuyBuildingResources(props)),
                                                    React.createElement("li", { className: resourceForRentTarget },
                                                        React.createElement("a", { href: "#", className: "c-mega__resource-pop-toggle-target-toggle", onClick: mobileResourceForRentClick }, t.forRent),
                                                        renderRentPopularBuildingResources(props),
                                                        renderRentBuildingResources(props)))))),
                                    React.createElement("li", { className: "c-mega__back" },
                                        React.createElement("a", { onClick: props.onMobileBack },
                                            React.createElement("span", { className: "fal fa-long-arrow-left" }),
                                            React.createElement("span", null, t.resources)))))))),
                React.createElement("div", { className: "l-mega__logo" },
                    React.createElement("div", { className: "c-mega__logo" },
                        React.createElement("a", { href: "/" + currentLang },
                            React.createElement("img", { id: "okay-forbes-logo", alt: "OKAY.COM | Founding member of Forbes Global Properties", src: "/res/img/okay-logo-fgp.png" })))),
                React.createElement("div", { className: "l-mega__settings" },
                    React.createElement("nav", { className: "c-mega" },
                        React.createElement("ul", { className: "c-mega__settings" },
                            React.createElement("li", { className: accountClass },
                                React.createElement("a", { onClick: props.onMyAccountClick },
                                    React.createElement("span", { className: "far fa-user-circle " + userAlertClass }),
                                    displayName ? (React.createElement("span", { className: "c-mega__name" },
                                        displayName,
                                        isUnverified ? " - " + t.unverified : "")) : null,
                                    React.createElement("span", { className: "c-mega__text" }, t.myAccount)),
                                displayName && !isUnverified ? (React.createElement("ul", null,
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/profile/accountinfo" }, t.personalDetails)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/mydocument/pendingdocument" },
                                            t.pendingDocument,
                                            props.pendingDocumentCount
                                                ? " (" + props.pendingDocumentCount + ")"
                                                : "")),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/mydocument/signeddocument" }, t.signedDocument)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/myproperty/mylistings" }, t.mylisting)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/myproperty/myviewings" }, t.myviewing)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/profile/changepassword" }, t.changePassword)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/profile/alerts" }, t.alerts)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/profile/locations" }, t.myplaces)),
                                    React.createElement("li", null,
                                        React.createElement("a", { onClick: props.onLogoutClicked }, t.logout)))) : null,
                                displayName && isUnverified ? (React.createElement("ul", null,
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/account/resendverification" }, t.unverified)),
                                    React.createElement("li", null,
                                        React.createElement("a", { onClick: props.onLogoutClicked }, t.logout)))) : null,
                                !displayName ? (React.createElement("ul", null,
                                    React.createElement("li", null,
                                        React.createElement("a", { onClick: props.onLoginClicked }, t.signIn)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/account/register" }, t.createAccount)))) : null),
                            React.createElement("li", { className: favoriteClass },
                                React.createElement("a", { onClick: props.onFavoriteClick },
                                    React.createElement("span", { className: "far fa-heart" }),
                                    React.createElement("span", { className: "c-mega__text" }, t.favorite)),
                                React.createElement("ul", null,
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/profile/savedproperties" }, t.savedProperties)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/profile/savedsearch" }, t.savedSearches)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "/" + currentLang + "/profile/recentlyviewed" }, t.recentlyViewed))))))),
                React.createElement(LanguageSwitcher_1.default, { setLanguage: setLanguage, currentLang: currentLang, options: props.language.languages }),
                React.createElement("div", { className: "l-mega__search c-mega c-mega__search" },
                    React.createElement("a", { onClick: props.onSearchIconClick },
                        React.createElement("span", { className: "far fa-search" }))))),
        React.createElement(MegaMenuSearchPopup_1.default, null)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(megaMenuComponent);
